import { Typography } from '@mui/material';
import { StructuredAddressFields } from '@components/AddressCapture/ManualAddressEntry';
import type { LeadCaptureSectionProps } from '@components/LeadCaptureForm/LeadCaptureForm.types';

export const ServiceAddressSection = ({ formik }: LeadCaptureSectionProps) => {
  const headingPrefix = formik.values.customerType === 'RESIDENTIAL' ? 'Service' : 'Business';

  return (
    <>
      <Typography variant="body.emphasis" className="lead-capture-section-heading">
        {headingPrefix} Address
      </Typography>
      <StructuredAddressFields formik={formik} />
    </>
  );
};
